module.exports = __webpack_public_path__ + "static/media/red-cluster.c4c08ef4.svg";